export const customerAgreementsEndPoints = {
  customerAgreement: "customer-agreement",
  uploadCustomerAgreement: "upload-customer-agreement",
};

export const CustomerEndPoints = {
  createNewCustomer: "add-customer",
  deleteCustomer: "delete-customer",
  editCustomer: "update-customer",
  getCustomers: "get-all-customers",
  getCustomer: "get-customer-by-id",
  getCustomerByEmail: "get-customer-by-email",
  getPresignedUrl: "get-presigned-url",
};

export const productEndPoints = {
  createNewProduct: "products/",
  editProduct: "products/",
  getProducts: "products/",
};

export const endpoints = {
  addUser: "add-user",
  deleteUser: "delete-user",
  getUsers: "get-users",
  getUserByEmail: "get-user",
  checkUserExists: "check-user",
};

export const orderEndpoints = {
  //cancelOrder: "cancel-order",
  getOrder: "get-order-details-by-id",
  editOrder: "change-order-status",
  createOrder: "create-order",
  getOrders: (emailId: string) => `get-orders/${emailId}`,
  updateOrder: (orderId: string) => `update-order/${orderId}`,
  getOrderIds: (customerId: string) => `get-order-ids/${customerId}`,
};

export const productInventoryEndPoints = {
  productInventory: "product-inventory",
};

export const shipmentEndpoints = {
  getOrderByStatus: "get-order-by-status",
  updateShipment: "update-shipment",
};

export const cartEndpoints = {
  getCartByCustomerId: "cart",
  updateCartByCustomerId: "cart",
};

export const inventoryEndPoints = {
  lockInventory: "lock-inventory",
  unlockInventory: "unlock-inventory",
};

export const orderPaymentEndPoints = {
  updateOrderPayment: "orders",
  getOrderPayment: "orders",
};

export const invoiceEndPoints = {
  downloadInvoice: "download-invoice",
  getInvoiceDetails: "get-invoice",
  updateInvoice: "update-invoice",
};

export const ledgerEndPoints = {
  download: "ledgers/download",
  base: "ledgers",
};

export const WishlistEndPoints = {
  getWishlistProducts: (customerId: string) => `wishlist/${customerId}`,
  updateWishlistProduct: "wishlist",
};

export const creditNoteEndPoints = {
  download: "download-credit-note",
  preview: "preview-credit-note",
  edit: "edit-credit-note",
  getAllCreditNotes: "get-all-credit-notes",
  delete: "delete-credit-note",
  save: "confirm-credit-note",
  getInvoiceFromOrders: "invoice-from-orders",
};

export const publicEndpoints = {
  signup: "sign-up",
  signin: "signin",
};

export const notificationEndPoints = {
  getNotifications: (customerId: string) => `notification/${customerId}`,
  subscribeToRestock: "notification",
  markAsRead: (notificationId: string) => `read-notification/${notificationId}`,
};
